"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages = {
    number: 'Expected type is "Number".',
    max: 'Exceed expected value.',
    min: 'Below expected value.',
};
exports.default = messages;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/number/messages.js
// module id = 324
// module chunks = 0